import { render, staticRenderFns } from "./discoverFive.vue?vue&type=template&id=7bd1535e&"
import script from "./discoverFive.vue?vue&type=script&lang=js&"
export * from "./discoverFive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports